import type { Approval } from "../../../api/types/approvalTypes";
import { approvalItemTypeCaptionsMap } from "../../../utilities/enumCaptions";

export const searchApprovals = (approvals: Approval[], searchTerm: string) =>
  searchTerm
    ? approvals.filter(
        (approval) =>
          approval.itemName.toLocaleLowerCase().includes(searchTerm) ||
          (approvalItemTypeCaptionsMap[approval.itemType] ?? "").toLocaleLowerCase().includes(searchTerm)
      )
    : [...approvals];
